import { render } from "./IconMail.vue?vue&type=template&id=1b3a45fb"
const script = {}

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__